export default {"src":"/_next/static/image/src/images/banner-fullwidth-purple.a740e181c910e39db19f77da720a7285.svg","height":572,"width":316};